import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=a5ee24ca&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=a5ee24ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ee24ca",
  null
  
)

export default component.exports